/* eslint-disable max-len */
import { Allotment } from 'allotment';
import 'allotment/dist/style.css';
import React, { ComponentType, ReactNode } from 'react';
import styled from 'styled-components';
import { Colors, remInPx } from '../../ui';
import { Flexer, Title } from '../dashboard/elements/LayoutElements';

{/* <Page2>
    <Page2.Navigation>
        <NewNavigationView />
    </Page2.Navigation>
    <Page2.Main>
        <Page2.Header>Test</Page2.Header>
        <Page2.Content>
            Content
        </Page2.Content>
    </Page2.Main>
</Page2> */}

const BaseFrame = styled.div`
    position: absolute;
    inset: 0;

    --focus-border: 2px solid ${Colors.borderLight};
    --separator-border: ${Colors.borderLight};
`;

const TopRight = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    padding: .75rem;
    z-index: 1;
    display: flex;
    align-items: center;
`;

const Header = styled.div<{ float?: boolean }>`
    position: ${p => p.float ? 'absolute' : 'relative'};
    top: 0;
    left: 0;
    width: 100%;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: start;
    flex: 0 0 4rem;
    background: #F9FAFC;
`;

const HeaderRight = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
`;

const PageTitle = styled(Title)`
    margin: .375rem 2rem .375rem;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.5em;
    color: ${p => p.color || Colors.text};
`;

const Content = styled.div`
    min-width: 54rem;
    flex: 1 1 auto;
    padding: 0 2rem;
    background: #F9FAFC;
`;

const Scroll = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    position: absolute;
    inset: 0;
    overflow: auto;
`;

export type Page2Props = {
    children: ReactNode,
    navigation?: ComponentType,
};

const Base = React.memo<Page2Props>(({ children, navigation }) => {
    return <BaseFrame>
        <Allotment proportionalLayout={false}>
            {navigation &&
                <Allotment.Pane preferredSize={remInPx(22)} maxSize={remInPx(32)} minSize={remInPx(18)}>
                    <Flexer inset flex="column">
                        {React.createElement(navigation)}
                    </Flexer>
                </Allotment.Pane>
            }
            <Allotment.Pane>
                <Flexer inset flex="column">
                    {children}
                </Flexer>
            </Allotment.Pane>
        </Allotment>
    </BaseFrame>;
});

/* --------------------------------- Export --------------------------------- */

export const Page2 = Object.assign(Base, {
    TopRight,
    Header,
    HeaderRight,
    HeaderTitle: PageTitle,
    Title: PageTitle,
    Content,
    Scroll,
});
